import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';
import { DataStore } from './DataStore/DataStore';
import { Error404 } from './ErrorPage/Error404';
import { GamePage } from './GamePage/GamePage';
import { LoginPage } from './LoginPage/LoginPage';
import { MainNavBar } from './MainNavbar/MainNavbar';
import { MainPage } from './MainPage/MainPage';

function App() {
  return (
    <DataStore>
      <Router>
        <MainNavBar />
        <Switch>

          <Route path="/" exact component={MainPage} />

          <Route path="/login" exact component={LoginPage} />

          <Route path="/play" exact component={GamePage} />

          <Route component={Error404} />

        </Switch>
      </Router>
    </DataStore>
  );
}

export default App;
